import React from "react";

import { Row } from "react-bootstrap";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import MasterDetailSection from "./MasterDetailSection";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/asistencia_spa",
    label: "Asistencia Spa",
  },
  {
    path: "/proyecciones",
    label: "Proyecciones",
    isActive: true,
  },
];

function ProyeccionesAsistenciaSpa() {
  return (
    <Page
      title="Proyecciones e historial de asistencias para Spa"
      description="Listas de asistencia pasadas y futuras para Spa."
      breadCrumbs={breadCrumbs}
    >
      <Row className="justify-content-center">
        <div className="col-xs-12 col-md-10 col-xxl-10">
          <MasterDetailSection />
        </div>
      </Row>
    </Page>
  );
}

export default ProyeccionesAsistenciaSpa;
